// src/utils/newstore.ts
interface NewStoreFormData {
  storeId?: string;
  associateId?: string;
  cartId?: string;
  profileId?: string;
  userInfo?: {
    id?: string;
    [key: string]: string | undefined;
  };
}

interface ExternalIdentity {
  identityProvider: string;
  identity: string;
}

interface NewStoreWindow {
  auth?: {
    accessToken: string;
  };
  contextProps?: {
    formData: NewStoreFormData;
  };
  externalIdentity?: string;
  externalIdentities?: ExternalIdentity[];
}
declare global {
  interface Window {
    NEWSTORE?: NewStoreWindow;
  }
}

export function getNewStoreData(): {
  accessToken: string | null;
  storeId: string | null;
  associateId: string | null;
  externalId: string | null;
  profileId: string | null;
} {
  if (!window.NEWSTORE) {
    if (window.location.hash) {
      try {
        window.NEWSTORE = JSON.parse(
          atob(window.location.hash.replace(/^#/, ''))
        );
      } catch {
        window.NEWSTORE = {};
      }
    } else {
      window.NEWSTORE = {
        auth: { accessToken: 'test' },
        contextProps: {
          formData: {
            storeId: '053', associateId: 'abc_123', cartId: '123', profileId: 'df0ec1b8-55fc-4daa-b974-ace17d327fb3'
          },
        },
        externalIdentities: [{
          identityProvider: "nsi-integrations",
          identity: 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI2ZTE1ZTRmZi0yYmE1LTQ1NDAtOGIxNC1jMzQyZTUwNGU3ZDQiLCJpYXQiOjE3NTQwMjUwMjQsImV4cCI6MTc1NTgyNTAyNCwicm9sZXMiOlsiZW5ncmF2aW5nIl19.QoiYrdrmT5SfAYwIBuxZM6Kqr50OwSryohnenohFx9g'
        }
        ]
      };
    }
  }

  const accessToken = window?.NEWSTORE?.auth?.accessToken ?? null;
  const storeId = window?.NEWSTORE?.contextProps?.formData.storeId ?? null;
  const profileId = window?.NEWSTORE?.contextProps?.formData.profileId ?? null;
  const associateId =
    window?.NEWSTORE?.contextProps?.formData.associateId ?? null;
  const nsiIntegration = window?.NEWSTORE?.externalIdentities?.find(e => e.identityProvider === process.env.REACT_APP_WEBVIEW_INTEGRATION_IDENTITY);
  const externalId = nsiIntegration?.identity ?? null;
  return { accessToken, storeId, associateId, externalId, profileId };
}
